import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '@app/Services/api.base.service';
import { UtilService } from '@app/Services/util.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ISelectedRole, IUsersDetail } from '../Models/IUsersDetail';
import { IRoles } from '../Models/IRoles';
import { IUserInfo } from '../Models/IUserInfo';
import { roles } from '../constants/roles';
import { rolesdef } from '../constants/role-def'
import { MessageService } from 'primeng/api';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import _ from 'lodash';
import { IGridCols, IKeyValuePair, INumKeyValuePair } from '../Models/IGridCols';
import { IDropdownConfig } from '../Models/IDeviceMetadata';
import { ICountryList } from '../Models/ICountryList';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [MessageService]
})
export class UsersComponent implements OnInit {

  userInfo: IUsersDetail[];
  roleList: IRoles[];
  roleListE: IRoles[] = [];
  cols: Array<IGridCols>;
  closeResult: string;
  contentHeader: string;
  roleDrpdwnConfig: IDropdownConfig;
  txtEmail: string = '';
  modalReference: NgbModalRef;
  showCreateUser: boolean = true;
  showOems: boolean = false;
  isEdit: boolean = false;
  userID: string;
  labels: any;
  messages: any;
  selectedRole: Array<ISelectedRole> = [];
  selectedRl: string;
  selectedPermission: string = 'N';
  noData: boolean = false;
  isPagination: boolean = true;
  isLoading: boolean = false;
  ShowDailog: boolean = false;
  showDeletemodal: boolean = false;
  selectedEmail: string;
  formInvalid: boolean;
  newUser: IUserInfo = { email: '', id: '', roleCode: '', oemid: '', canCreateUser: '', isActive: true, countryAccess: [] };
  authFId: string;
  oemIdList: Array<IKeyValuePair> = [];
  regionData: Array<ICountryList> = [];
  regionDataE: Array<ICountryList> = [];
  selectedRegion: any[] = [];
  accessRegions: Array<ICountryList> = [];
  selectedOemId: string;
  selectedOem: any[];
  showRoles: boolean;
  usersDetailsApiUrl: string;
  currentAuthUserRole: string;
  rolesConst: any;
  showOemCol: string;
  currentUserStatusEvent: any;
  currentUserRecord: IUsersDetail;
  selectedUserStatus: boolean;
  showRegions: boolean = false;
  regionConfig: any;
  validateRegionsMsg: string = '';
  regionSelectPlaceholder: string = '';
  tableCellClass = 'table-cell'
  constructor(
    private readonly baseService: BaseAPIService,
    private readonly auth: AuthenticationService,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService,
    private readonly _validateService: ValidateRulesService) { }

  ngOnInit() {
    this.isLoading = true;
    this.labels = label;
    this.messages = message;
    this.selectedRl = '';
    this.selectedOemId = '';
    this.selectedRegion = [];
    //below check evaluates to only 'master' user
    this.showOemCol = this.auth.authenticatedRoleCd === rolesdef.enduser || this.auth.authenticatedRoleCd === rolesdef.cuserW ? 'none' : this.tableCellClass;
    this.showRegions = this.auth.authenticatedRoleCd === rolesdef.enduser || this.auth.authenticatedRoleCd === rolesdef.cuserW;
    this.cols = [
      { field: 'name', header: this.labels.tableHeaderName, width: '15%', display: this.tableCellClass },
      { field: 'email', header: this.labels.tableHeaderEmail, width: '15%', display: this.tableCellClass },
      { field: 'roleDesc', header: this.labels.tableHeaderRole, width: '10%', display: this.tableCellClass },
      { field: 'oemName', header: this.labels.tableHeaderOEMOrParent, width: '10%', data: 'oid', display: this.showOemCol },
      { field: 'parentUser', display: 'none' },
      { field: 'cooler_count', header: this.labels.tableHeaderDevices, width: '15%', display: this.tableCellClass }
    ];

    this.authFId = this.auth.authenticatedUserFId;
    this.currentAuthUserRole = this.auth.authenticatedRoleCd;
    this.rolesConst = rolesdef;
    switch (this.auth.authenticatedRoleCd) {
      case rolesdef.master:
        this.GetUserRoles();
        this.GetOemIds();
        this.usersDetailsApiUrl = '/User/AllUsers';
        this.GetUserDetails(this.usersDetailsApiUrl);
        break;
      case rolesdef.oemuser:
        this.GetOemIds();
        break;
      case rolesdef.enduser:
        this.usersDetailsApiUrl = '/User/AllChildUsersByEndUser';
        this.GetCountries(false);
        this.GetUserDetails(this.usersDetailsApiUrl);
        break;
      case rolesdef.cuserW:
        this.usersDetailsApiUrl = '/User/AllChildUsersByEndUser';
        this.GetUserDetails(this.usersDetailsApiUrl);
        this.GetCountries(true);
        break;
      default:
        break;
    }
  }

  public GetUserDetails(apiUrl) {
    this.baseService.GET(apiUrl)
      .subscribe((result: IUsersDetail[]) => {
        if (result && result.length > 0) {
          this.userInfo = result;
          this.isLoading = false;
          this.isPagination = this.userInfo.length < 10 ? false : true;
        }
        else {
          this.noData = true;
          this.isPagination = false;
          this.isLoading = false;
        }
      });
  }

  public GetCountries(isCWUser: boolean) {
    this.regionSelectPlaceholder = this.translate.instant(this.labels.allCountries);
    const apiUrl = '/Misc/GetAllCountries';
    this.baseService.GET(apiUrl)
      .subscribe((result: Array<INumKeyValuePair>) => {
        if (result && result.length > 0) {
          result.forEach(item => {
            this.regionData.push({
              countryCd: item.key,
              countryName: item.value
            });
            this.regionDataE.push({
              countryCd: item.key,
              countryName: item.value
            });
          });
          if (isCWUser === true) {
            this.GetChildWUserCountries();
          }
        }
      });
  }

  public GetChildWUserCountries() {
    const apiUrl = '/User/CountryAccessForAdminChildUser';
    this.baseService.GET(apiUrl)
      .subscribe((result: Array<number>) => {
        if (result && result.length > 0) {
          if (result[0] !== 0) {
            this.regionSelectPlaceholder = this.translate.instant(this.labels.selectCountry);
            this.accessRegions = [];
            result.forEach(item => {
              const current = this.regionData.find(x => x.countryCd === item);
              this.accessRegions.push({
                countryCd: current.countryCd,
                countryName: current.countryName
              });
            });

            this.regionData = [];
            this.regionDataE = [];
            this.accessRegions.forEach(element => {
              this.regionData.push({
                countryCd: element.countryCd,
                countryName: element.countryName
              });
              this.regionDataE.push({
                countryCd: element.countryCd,
                countryName: element.countryName
              });
            });

            this.selectedRegion = [];
            this.regionData.forEach(element => {
              this.selectedRegion.push({
                countryCd: element.countryCd,
                countryName: element.countryName
              });
            });
          }
          else {
            this.accessRegions.push({
              countryCd: 0,
              countryName: this.labels.selectAllCountries
            });
            this.regionSelectPlaceholder = this.translate.instant(this.labels.allCountries);
          }

        }
      });
  }

  public GetUserRoles() {
    this.baseService.GET('/User/AdminRoles')
      .subscribe((response: Array<IKeyValuePair>) => {
        response.forEach((element) => {
          this.roleListE.push({ roleCd: element.key, roleDesc: element.value });
        });
      });
  }

  public GetOemIds() {
    this.baseService.GET('/OEM/OEMIds')
      .subscribe((response: Array<IKeyValuePair>) => {
        this.oemIdList = response;
      });
  }

  onEditUserStatus(rowData: any, event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.currentUserStatusEvent = event;
    this.userID = rowData.user_id;
    this.selectedEmail = rowData.email;
    this.messageService.clear();
    this.showDeletemodal = true;
    this.currentUserRecord = rowData;
  }

  onUserStatusChangeConfirm() {
    this.isLoading = true;
    this.messageService.clear('c');
    this.showDeletemodal = false;
    this.currentUserRecord.isActive = !this.currentUserRecord.isActive;
    this.PrepCurrentUserStatus(this.currentUserRecord);
  }

  cancel() {
    this.ShowDailog = false;
    this.showDeletemodal = false;
    this.ResetUserobject();
  }

  onReject() {
    this.messageService.clear('c');
  }


  private PrepCurrentUserStatus(userInfo: IUsersDetail) {
    this.isEdit = true;
    this.newUser.id = userInfo.id;
    this.selectedRl = userInfo.roleCode;
    this.txtEmail = userInfo.email;
    this.selectedOemId = userInfo.oemId;
    this.selectedUserStatus = userInfo.isActive;
    if (this.currentUserStatusEvent !== undefined) {
      this.currentUserStatusEvent.target.checked = !this.currentUserStatusEvent.target.checked;
    }
    this.SaveorUpdateUser();
  }

  public AddUser() {
    this.formInvalid = true;
    this.isEdit = false;
    this.ResetUserobject();
    this.Configs();
    this.roleList = this.roleListE;
    this.contentHeader = this.labels.addUserDetails;
    this.ShowDailog = true;
    this.showCreateUser = this.auth.authenticatedRoleCd === rolesdef.enduser || this.auth.authenticatedRoleCd === rolesdef.cuserW;
  }

  public EditUser(selectedUser: IUsersDetail) {
    this.formInvalid = false;
    this.Configs();
    this.roleList = this.roleListE;
    this.regionData = this.regionDataE;
    this.contentHeader = this.labels.updateUserDetails;
    this.ShowDailog = true;
    this.isEdit = true;
    this.showRoles = [rolesdef.master, rolesdef.oemuser, rolesdef.enduser].includes(selectedUser.roleCode);
    this.txtEmail = selectedUser.email;
    this.selectedRl = selectedUser.roleCode;
    this.newUser.id = selectedUser.id;
    this.showOems = selectedUser.roleCode === rolesdef.oemuser;
    this.selectedOemId = selectedUser.oemId;
    this.newUser.roleCode = selectedUser.roleCode;
    this.showCreateUser = selectedUser.roleCode == rolesdef.cuserW;
    this.selectedPermission = selectedUser.roleCode === rolesdef.cuserW ? 'Y' : 'N';
    this.selectedUserStatus = selectedUser.isActive;
    this.selectedRole = [{
      "roleCd": selectedUser.roleCode,
      "roleDesc": selectedUser.roleDesc
    }];

    this.selectedOem = [{
      "oemId": selectedUser.oemId,
      "oemDesc": `${selectedUser.oemName}-${selectedUser.oid}`
    }];

    this.selectedRl = this.selectedRole[0].roleCd;
    this.selectedOemId = this.selectedOem[0].oemId;
    if (this.regionData.length > 0) {
      this.selectedRegion = [];
      this.selectedRegion = selectedUser.countryAccess;
    }
  }

  public ResetUserobject() {
    this.newUser = { email: '', id: '', roleCode: '', oemid: '', canCreateUser: '', isActive: true, countryAccess: [] };
    this.txtEmail = '';
    this.selectedRole = [];
    this.selectedOem = [];
    this.selectedOemId = '';
    this.selectedRl = '';
    this.showOems = false;

    if (this.auth.authenticatedRoleCd !== rolesdef.cuserW) {
      this.selectedRegion = [];
      this.regionSelectPlaceholder = this.translate.instant(this.labels.allCountries);
      this.regionData = this.regionDataE;
    }
    else {
      if (this.accessRegions[0].countryCd === 0) {
        this.regionSelectPlaceholder = this.translate.instant(this.labels.allCountries);
        this.selectedRegion = [];
      }

      else {
        this.regionData = [];
        this.accessRegions.forEach(sr => {
          this.regionData.push(sr);
        });
        this.selectedRegion = this.regionData;
        this.regionSelectPlaceholder = this.translate.instant(this.labels.selectCountry);
      }

    }
    this.showRoles = this.auth.authenticatedRoleCd === rolesdef.master ? true : false;
  }

  public SaveUser(el: any) {

    if (this.txtEmail === '') {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidEmail), detail: this.translate.instant(this.messages.notEmptyEmail), key: 'error' });
      el.focus();
    }
    else if (!UtilService.IsValidEmail(this.txtEmail)) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidEmail), detail: this.translate.instant(this.messages.notValidEmail), key: 'error' });
      el.focus();
    }
    else if (this.showRoles && (this.selectedRl === null || this.selectedRl === undefined || this.selectedRl === '')) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidRole), detail: this.translate.instant(this.messages.notEmptyRole), key: 'error' });
    }
    else if (this.showOems && (this.selectedOemId === null || this.selectedOemId === undefined || this.selectedOemId === '')) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidOem), detail: this.translate.instant(this.messages.notEmptyOem), key: 'error' });
    } else if (this.showRegions && this.selectedRegion.length < 1) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.moreCountriesGen), detail: this.translate.instant(this.messages.notEmptyOem), key: 'error' });
    } else {
      this.newUser.email = this.txtEmail;
      if (this.showRoles) {
        this.newUser.roleCode = this.selectedRl;
        if (this.showOems && this.selectedRl === rolesdef.oemuser && this.selectedOemId !== null) {
          this.newUser.oemid = this.selectedOemId;
        }
      }
      if (this.showCreateUser) {
        this.newUser.canCreateUser = this.selectedPermission === 'Y' ? "true" : "false";
      }
      if (this.showRegions) {
        this.newUser.countryAccess = [];
        if (this.selectedRegion.length > 0) {
          for (const item in this.selectedRegion) {
            if (this.selectedRegion.hasOwnProperty(item)) {
              this.newUser.countryAccess.push(this.selectedRegion[item]);
            }
          }
        }
      }
    }

    this.isLoading = true;
    this.SaveorUpdateUser();
  }

  public SaveorUpdateUser() {
    let apiUrl = '';
    let requestBody = {};
    const customHeaders = {};
    let userAddUpdateObs;

    if (this.isEdit) {
      apiUrl = [rolesdef.master].includes(this.auth.authenticatedRoleCd)
        ? '/User/UpdateAdminUser' : '/User/UpdateChildUser';
      this.newUser.roleCode = this.selectedRl;
      this.newUser.email = this.txtEmail;
      this.newUser.oemid = this.selectedOemId;
      this.newUser.isActive = this.selectedUserStatus;
      requestBody = this.newUser;
      userAddUpdateObs = this.baseService.PutWithHeaders(apiUrl, customHeaders, requestBody);
    }
    else {
      if ([rolesdef.master].includes(this.auth.authenticatedRoleCd)) {
        apiUrl = '/User/AddAdminUser';
        customHeaders['emailId'] = this.newUser.email;
        if (this.showRoles) {
          customHeaders['roleCd'] = this.newUser.roleCode;
        }
        if (this.showOems && this.newUser.oemid !== null && this.newUser.oemid !== '') {
          customHeaders['oEMId'] = this.newUser.oemid.toString();
        }
        customHeaders['canCreateUser'] = this.newUser.canCreateUser;
      }
      else {
        apiUrl = '/User/AddChildUser';
        requestBody = this.newUser;
      }
      userAddUpdateObs = this.baseService.PostWithHeaders(apiUrl, customHeaders, requestBody);
    }

    userAddUpdateObs.subscribe((response: number) => {
      this.isLoading = false;
      if (response !== null) {
        if (response > 0) {
          if (!this.isEdit) {
            this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `${this.txtEmail} ${this.translate.instant(this.messages.addUser)}`, key: 'success' });
          }
          else {
            this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `${this.txtEmail} ${this.translate.instant(this.messages.updateUser)}`, key: 'success' });
            this.isEdit = false;
          }
        }
        else {
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAddUser), key: 'error' });
        }
      }
      else {
        this.isEdit = false;
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.updateUser), key: 'success' });
      }
      this.ShowDailog = false;
      this.GetUserDetails(this.usersDetailsApiUrl);
    },
      (error) => {
        this.isLoading = false;
        this.showDeletemodal = false;
        this.ShowDailog = false;
        switch (error.error) {
          case this.messages.userExist:
            this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.userExist), key: 'error' });
            break;
          case this.messages.notValidRoleEmail:
            this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.notValidRoleEmail), key: 'error' });
            break;
          case this.messages.invalidRole:
            this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.invalidRole), key: 'error' });
            break;
          case this.messages.notvalidOem:
            this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.notvalidOem), key: 'error' });
            break;
          default:
            this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAddUser), key: 'error' });
            break;
        }
      });
  }

  public roleSelectionChanged(event) {
    this.validateForm(event);
    switch (this.selectedRl) {
      case rolesdef.oemuser:
        this.showOems = true;
        this.selectedOemId === (this.isEdit ? this.selectedOemId : '');
        break;
      default:
        this.showCreateUser = false;
        this.showOems = false;
        this.roleList = this.roleListE;
        break;
    }
  }

  public oemIdSelectionChanged(event) {
    this.validateForm(event);
  }

  public changePermission(event) {
    this.selectedRl = this.selectedPermission === 'Y' ? rolesdef.cuserW : rolesdef.cuserR;
  }

  public Configs() {
    this.roleDrpdwnConfig = {
      displayKey: "roleDesc",
      search: false,
      placeholder: this.translate.instant(this.labels.select)
    };

    this.regionConfig = {
      displayKey: "countryName",
      search: true,
      height: '200px',
      placeholder: this.regionSelectPlaceholder
    }

  }

  public removeRole() {
    this.selectedRole = [];
    this.roleListE = roles;
    this.roleList = roles;
  }

  public validateForm(event) {

    this.formInvalid = this._validateService.emailElement(this.txtEmail, 'Email') === '' ? false : true;

    if (this.showRoles) {
      this.formInvalid = this._validateService.requiredElement(this.selectedRl, 'Role', 1, 50) === '' ? false : true;
    }

    if (this.showOems) {
      this.formInvalid = this._validateService.requiredElement(this.selectedOemId.toString(), 'OEM', 1, 50) === '' ? false : true;
    }
    if (this.showRegions && this.selectedRegion.length < 1) {
      this.formInvalid = true;
    }

    return false;

  }
  public ExportUser() {
    this.isLoading = true;
    let api: string = '';
    if (this.auth.authenticatedRoleCd === rolesdef.master) {
      api = "/User/ExportMasterUserData";
    }
    else {
      api = "/User/ExportEndUserData";
    }
    this.baseService.DOWNLOAD(api, null).subscribe((result) => {
      const fileName = `UsersDetails_${UtilService.FormatDate(new Date()).toString().replace(' ', '_')}.xlsx`;
      const blob = new Blob([result], { type: "application/octet-stream" });
      saveAs(blob, fileName);
      this.isLoading = false;
    });
  }

}
